import { Trans } from '@lingui/macro';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { type FC } from 'react';

interface Props {
  metrics: {
    deviceId: string;
    name: string;
    accessorKey: string;
  }[];
}

export const AccessorsTable: FC<Props> = ({ metrics }) => {
  return (
    <TableContainer>
      <Table size="small" padding="checkbox" sx={{ border: 1, borderColor: 'divider' }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Trans>ID dispositivo</Trans>
            </TableCell>
            <TableCell>
              <Trans>Métrica</Trans>
            </TableCell>
            <TableCell>
              <Trans>Accesor</Trans>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {metrics.map(({ deviceId, name, accessorKey }) => (
            <TableRow key={accessorKey}>
              <TableCell>{deviceId}</TableCell>
              <TableCell>{name}</TableCell>
              <TableCell>{accessorKey}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
